/** Suscripciones PRO (1.0 admin Subscriptions): `subscriptions/{uid}` por estado; el alta manual se hace desde la ficha de usuario. */
import { useEffect, useState, type ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { errorText } from '../api.js';
import { db } from '../firebase.js';
import { btn, muted, Notice, str, Table, td, when } from '../lib/ui.js';

type Doc = Record<string, unknown>;
const STATUSES = ['active', 'past_due', 'canceled', 'expired'] as const;

export function SubscriptionsPage(): ReactElement {
  const [status, setStatus] = useState<string>('active');
  const [rows, setRows] = useState<Doc[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    setRows(null);
    getDocs(query(collection(db, 'subscriptions'), where('status', '==', status), limit(300)))
      .then((s) => {
        const list: Doc[] = s.docs.map((d) => ({ id: d.id, ...d.data() }));
        list.sort((a, b) => {
          const ta = (a.updated_at as { toMillis?: () => number } | undefined)?.toMillis?.() ?? 0;
          const tb = (b.updated_at as { toMillis?: () => number } | undefined)?.toMillis?.() ?? 0;
          return tb - ta;
        });
        setRows(list);
      })
      .catch((e: unknown) => {
        setError(errorText(e));
        setRows([]);
      });
  }, [status]);
  return (
    <>
      <h1 style={{ margin: 0 }}>Suscripciones PRO</h1>
      <p style={muted}>
        Origen: stripe (web), app_store / play_store (apps, RevenueCat) o admin_grant. Para conceder
        o retirar PRO a mano: ficha del usuario.
      </p>
      <div style={{ display: 'flex', gap: 8 }}>
        {STATUSES.map((s) => (
          <button
            key={s}
            type="button"
            style={btn(status === s)}
            onClick={() => {
              setStatus(s);
            }}
          >
            {s}
          </button>
        ))}
      </div>
      <Notice text={error} error />
      {!rows && <p style={muted}>Cargando…</p>}
      {rows && (
        <Table
          head={['Usuario', 'Nivel', 'Origen', 'Producto', 'Renueva', 'Cancela', 'Actualizado']}
        >
          {rows.map((s) => (
            <tr key={str(s.id)}>
              <td style={td}>
                <Link to={`/usuarios/${str(s.uid)}`}>{str(s.uid)}</Link>
              </td>
              <td style={td}>{str(s.tier)}</td>
              <td style={td}>{str(s.source)}</td>
              <td style={td}>{str(s.product_id)}</td>
              <td style={td}>{when(s.renews_at)}</td>
              <td style={td}>{when(s.cancel_at)}</td>
              <td style={td}>{when(s.updated_at)}</td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td style={td} colSpan={7}>
                Ninguna.
              </td>
            </tr>
          )}
        </Table>
      )}
    </>
  );
}
